// Path operations utilities for CustomMode

// Check if a path is already closed (starts and ends with the same point)
export const isPathClosed = (customPath, startId) => {
  return customPath.length > 1 && 
         customPath[0].id === startId && 
         customPath[customPath.length - 1].id === startId;
};

// Check if all points have been selected
export const areAllPointsSelected = (locations, customPath) => {
  return locations.every(loc => 
    customPath.some(point => point.id === loc.id)
  );
};

// Find a point by ID in locations array
export const findPointById = (locations, id) => {
  return locations.find(loc => loc.id === id);
};

// Convert path of point objects to path of IDs
export const convertPathToIds = (customPath) => {
  return customPath.map(point => point.id);
}; 